<template>
  <div id="point-receipt-inner" media="print" style="padding-bottom: 50px">
    <div
      style="
        display: flex;
        flex-direction: column;
        size: 48mm;
        margin-bottom: 100px;
        min-height: 100px;
        height: 100%;
        padding-bottom: 100px;
        page-break-after: always;
        border-bottom: 1px solid black;
      "
    >
      <div class="d-flex flex-column" style="display: flex; flex-direction: column">
        <div
          class="d-flex justify-center"
          style="display: flex; justify-content: center; font-size: 20px"
        >
          <span> {{ store.name }}</span>
        </div>
        <div
          class="d-flex justify-center"
          style="
            display: flex;
            justify-content: center;
            margin: 1px 10px 80px 10px;
            color: gray;
            font-size: 14px;
            margin-bottom: 80px;
          "
        >
          <span> {{ store.address }}</span>
        </div>
        <div style="display: flex; flex-direction: column; margin-bottom: 20px; margin-top: 50px">
          <div
            class="d-flex flex-row justify-space-between"
            style="margin: 1px; display: flex; flex-direction: row; justify-content: space-between"
            v-for="product in transactionPreview.products"
            :key="product.product_id"
          >
            <span>
              {{ product.quantity }} x
              {{ product.name[lang] }}
            </span>
            <span>
              {{ product.points_per_row }}
            </span>
          </div>
        </div>
      </div>
      <div
        style="border-bottom: 3px solid black; margin: 20px; margin-bottom: 70px; margin-top: 70px"
      ></div>
      <div
        class="d-flex justify-center"
        style="
          display: flex;
          justify-content: center;
          margin: 15px 0;
          margin-top: 80px;
          margin-bottom: 80px;
        "
      >
        <b
          >{{ translations[`total_${storeMode}`][lang] }}:
          {{ transactionPreview.new_user_points }}</b
        >
      </div>
      <div
        v-if="couponsExist"
        class="d-flex justify-center"
        style="display: flex; justify-content: center; margin: 15px 0; margin-bottom: 20px"
      >
        <span>{{ translations.availableCoupons[lang] }}</span>
      </div>
    </div>
    <div style="margin-top: 150px">---------------------------------</div>

    <br /><br /><br /><br /><br />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import translations from '@/utils/translations/storePanel/newTransaction/pointReceipt';

export default {
  name: 'PointReceipt',
  mixins: [translations],

  computed: {
    ...mapState(['loading', 'errorMessage']),
    ...mapState('storePanel', ['store']),
    ...mapState('storePanel/transactions', [
      'transaction',
      'transactionPreview',
      'generalCouponClaims',
      'coupons',
      'samplingCoupons',
    ]),
    couponsExist() {
      return (
        this.generalCouponClaims.length + this.coupons.length + this.samplingCoupons.length > 0
      );
    },
    lang() {
      return this.$route.params.lang;
    },
    storeMode() {
      return this.$store.state.store?.display_mode || 'points';
    },
  },
};
</script>

<style scoped>
@media print {
  #point-receipt-inner {
    display: flex !important;
    margin: 0;
    size: 48mm;
  }

  html,
  body {
    height: 99%;
    margin: 0;
    size: 48mm;
  }
}
@page {
  margin: 5mm;
  padding-bottom: 5cm;
  size: 48mm;
}
</style>
